import { GamesOrderType, SelectedGame } from "entities/modules/types";
import { create } from "zustand";

export type SelectedGamesDataStore = {
  orderType: GamesOrderType;
  tagSelectedGames: SelectedGame[];
  manualSelectedGames: SelectedGame[];
  selectedGames: SelectedGame[];
  setOrderType: (orderType: GamesOrderType) => void;
  setTagSelectedGames: (tagSelectedGames: SelectedGame[]) => void;
  setManualSelectedGames: (manualSelectedGames: SelectedGame[]) => void;
  setSelectedGames: (selectedGames: SelectedGame[]) => void;
  clearSelectedGamesData: () => void;
};

export const useSelectedGamesData = create<SelectedGamesDataStore>((set) => ({
  orderType: GamesOrderType.Random,
  tagSelectedGames: [],
  manualSelectedGames: [],
  selectedGames: [],
  setOrderType: (orderType) => set({ orderType }),
  setTagSelectedGames: (tagSelectedGames) => set({ tagSelectedGames }),
  setManualSelectedGames: (manualSelectedGames) => set({ manualSelectedGames }),
  setSelectedGames: (selectedGames) => set({ selectedGames }),
  clearSelectedGamesData: () =>
    set({
      orderType: GamesOrderType.Random,
      selectedGames: [],
      tagSelectedGames: [],
      manualSelectedGames: [],
    }),
}));
